import { render, staticRenderFns } from "./DeliveryItemList.vue?vue&type=template&id=3d48416e&"
import script from "./DeliveryItemList.vue?vue&type=script&lang=js&"
export * from "./DeliveryItemList.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryItemList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports